The SEEK products that the candidate may be surfaced in.

Currently, one code is defined:

- `ProactiveSourcing` indicates that the candidate may be viewed in SEEK Talent Search.
